module.exports = __webpack_public_path__ + "img/lukoil-logo-w.5a2dd619.svg";